module.exports = __webpack_public_path__ + "static/img/ip-right.9908d9c0.png";